import React from "react";
import "./ManagerSpeech.css";
import team from "../assets/wisam_ali.jpg";

export default function ManagerSpeech() {
 return (
    <section className="ManagerSpeech-page" dir="rtl">
      <h1 className="ManagerSpeech-title">كلمة مدير إذاعة صوت الحياة والأمل</h1>

      <div className="ManagerSpeech-body">
       

        <p>
          أيها الأحباء في كل مكان، نرحب بكم جميعًا عبر أثير إذاعة صوت الحياة
          والأمل AWR360، هذا الصوت الذي انطلق ليحمل رسالة الرجاء، وينشر نور الحق
          الإلهي إلى كل قلبٍ باحثٍ عن السلام والخلاص في المسيح يسوع.
        </p>

        <p>
          نحن في هذه الإذاعة نؤمن بأن الكلمة الحيّة من الكتاب المقدس هي مصدر
          النور والهداية، وهي الطريق المؤدي إلى الحياة الأبدية. رسالتنا هي أن
          نُعلن بشجاعةٍ ومحبةٍ بشارة الإنجيل الخالدة، وندعو الجميع إلى علاقةٍ
          حقيقيةٍ مع الله، الذي "يُريد أن جميع الناس يخلصون وإلى معرفة الحق
          يقبلون" (تيموثاوس الأولى 2:4).
        </p>

        <p>
          من خلال برامجنا الصوتية والمرئية، نسعى لأن نكون منبرًا للتعليم،
          والتشجيع، والتأمل في وعود الله، لكي يتقوى الإيمان، وتتعزز المحبة في
          قلوب المستمعين.
        </p>

        <p>
          لذلك نسعى أن نكون صوتًا يحمل كلمة الله الحيّة إلى القلوب المتعبة،
          والعقول الباحثة عن الحق. نحن نؤمن أن الكتاب المقدس هو كلمة الله الموحى
          بها، وهو الطريق الذي ينير خطوات الإنسان نحو ملكوت السماوات.
        </p>

        <p>
          ونحن نلتزم بتقديم رسالة الملائكة الثلاثة كما وردت في سفر الرؤيا،
          الإصحاح الرابع عشر، وهي الرسالة الأخيرة التي يوجهها الله إلى العالم
          قبل مجيء المسيح الثاني، لتكون دعوةً إلى التوبة والرجوع إلى الخالق.
        </p>

        <h3 className="ManagerSpeech-section-title">الرسالة الأولى</h3>
        <blockquote>
          "ثُمَّ رَأَيْتُ مَلاَكًا آخَرَ يَطِيرُ فِي وَسَطِ السَّمَاءِ، مَعَهُ
          بُشْرَى أَبَدِيَّةٌ، لِيُبَشِّرَ السَّاكِنِينَ عَلَى الأَرْضِ،
          وَكُلَّ أُمَّةٍ وَقَبِيلَةٍ وَلِسَانٍ وَشَعْبٍ، قَائِلًا بِصَوْتٍ
          عَظِيمٍ: خَافُوا اللهَ وَأَعْطُوهُ مَجْدًا، لأَنَّهُ قَدْ جَاءَتْ
          سَاعَةُ دَيْنُونَتِهِ، وَاسْجُدُوا لِصَانِعِ السَّمَاءِ وَالأَرْضِ
          وَالْبَحْرِ وَيَنَابِيعِ الْمِيَاهِ." (رؤيا 14:6-7)
        </blockquote>
        <p>
          هذه هي بشارة الإنجيل الأبدي، دعوةٌ مقدسةٌ للناس أن يرجعوا إلى عبادة
          الخالق، وأن يعيشوا لمجد الله، لأن وقت الدينونة قد بدأ. وهي نداءٌ
          لاحترام وصاياه، وخصوصًا وصية السبت التي تذكّرنا بالخالق.
        </p>

        <h3 className="ManagerSpeech-section-title">الرسالة الثانية</h3>
        <blockquote>
          "ثُمَّ تَبِعَهُ مَلاَكٌ آخَرُ، قَائِلًا: سَقَطَتْ! سَقَطَتْ بَابِلُ
          الْعَظِيمَةُ، الَّتِي سَقَتْ جَمِيعَ الأُمَمِ مِنْ خَمْرِ غَضَبِ
          زِنَاهَا." (رؤيا 14:8)
        </blockquote>
        <p>
          هذه الرسالة تُعلن سقوط بابل الروحية، أي نظام العبادة الزائف الذي
          استبدل حق الله بتقاليد البشر، وهي دعوةٌ لكل مؤمنٍ أن ينفصل عن الباطل
          ويثبت في الحق الإلهي. إنها نداءٌ إلى الرجوع إلى نقاوة الإيمان الكتابي.
        </p>

        <h3 className="ManagerSpeech-section-title">الرسالة الثالثة</h3>
        <blockquote>
          "ثُمَّ تَبِعَهُم مَلاَكٌ ثَالِثٌ، قَائِلًا بِصَوْتٍ عَظِيمٍ: إِنْ
          كَانَ أَحَدٌ يَسْجُدُ لِلوَحْشِ وَصُورَتِهِ، وَيَقْبَلُ سِمَةً عَلَى
          جَبْهَتِهِ أَوْ عَلَى يَدِهِ، فَهُوَ أَيْضًا سَيَشْرَبُ مِنْ خَمْرِ
          غَضَبِ اللهِ، المَصْبُوبِ صِرْفًا فِي كَأْسِ غَضَبِهِ." (رؤيا
          14:9-10)
        </blockquote>
        <p>
          إنها تحذيرٌ من عبادة الوحش وقبول سِمته — أي رفض وصايا الله الحقيقية،
          والخضوع لسلطةٍ بشريةٍ بديلة. ثم يُختم هذا المقطع بهذه الكلمات العظيمة:
        </p>
        <blockquote>
          "هُنَا صَبْرُ الْقِدِّيسِينَ، هُنَا الَّذِينَ يَحْفَظُونَ وَصَايَا
          اللهِ وَإِيمَانَ يَسُوعَ." (رؤيا 14:12)
        </blockquote>

        <p>
          هدفنا أن نكون صوتًا للحق في عالمٍ يزداد ظلامًا، وأن نستخدم وسائل
          الإعلام لنعلن أن الخلاص متاحٌ لكل إنسانٍ بالإيمان بيسوع المسيح ربًّا
          ومخلّصًا.
        </p>

        <p>
          نحن نعلن من خلال أثيرنا أن الوقت قريب، والمسيح آتٍ عن قريب. ندعوكم
          جميعًا إلى أن تكونوا جزءًا من هذه الدعوة المقدسة، أن تشاركوا في نشر
          بشارة الحياة والأمل، وأن تكونوا أنوارًا في هذا العالم المظلم.
        </p>

        <p>
          المسيح آتٍ ليجمع خاصته من كل الأمم والقبائل والألسنة. فلتستمر إذاعة
          "صوت الحياة والأمل AWR360" منبرًا للنور، وجسرًا يصل كلمة الرب إلى كل
          بيتٍ، وكل قلبٍ في العالم.
        </p>

        <p className="ManagerSpeech-closing">
          نحييكم، طاقمًا ومديرًا، من إذاعة صوت الحياة والأمل، ونقول لكم:<br />
          <strong>الرب يبارككم جميعًا.</strong>
        </p>
          <div className="ManagerSpeech-hero">
        <img src={team} alt="وسام علي " />
      </div>
      </div>
    </section>
  );
}

